__turbopack_context__.v({
  "body": "_4LzoGG_body",
  "modal": "_4LzoGG_modal",
});
